import './Contact.scss';

import React from 'react';
import { Form } from '../components/Form';
import { Mail, Phone, Pin } from '../components/Icons';

const MAP_SRC = 'https://www.google.com/maps?q=1215C+56+St,+Delta,+BC+V4L+2A6&output=embed';

const d = (ms: number) => ({ '--delay': `${ms}ms` } as React.CSSProperties);

export function Contact() {
  return (
    <>
      <section id="location" className="section location">
        <div className="container">
          <div className="head head--center">
            <span className="eyebrow reveal">Our location</span>
            <h2 className="reveal" style={d(80)}>
              Based in Ladner, Delta.
            </h2>
            <p className="lede reveal" style={d(160)}>
              Delivering painting services across Delta and the surrounding Lower Mainland from our office on 56
              Street.
            </p>
          </div>
          <div className="location__map reveal" style={d(200)}>
            <iframe src={MAP_SRC} title="Ivy League Painting office on Google Maps" loading="lazy" allowFullScreen referrerPolicy="no-referrer-when-downgrade" />
          </div>
        </div>
      </section>

      <section id="contact" className="section contact on-dark">
        <div className="contact__glow" aria-hidden="true" />
        <div className="container">
          <div className="head head--center contact__head">
            <span className="eyebrow reveal">Free quote</span>
            <h2 className="reveal" style={d(80)}>
              Ready for a<br />fresh coat?
            </h2>
            <p className="lede reveal" style={d(160)}>
              Contact us for a free, no-obligation quote today. We follow up within one business day.
            </p>
            <div className="contact__cta reveal" style={d(240)}>
              <a className="btn btn--blue" href="#quote-form">
                Get a free quote
              </a>
              <a className="btn btn--white" href="tel:+16043655225">
                <Phone /> (604) 365-5225
              </a>
            </div>
          </div>

          <div className="contact__panel reveal" id="quote-form" style={d(300)}>
            <div className="contact__details">
              <h3>Tell us about your project</h3>
              <p>
                Rooms, surfaces, colours you have in mind and timing. We'll come by, walk the space with you and
                leave a written quote.
              </p>
              <ul>
                <li>
                  <span className="icon-chip">
                    <Phone />
                  </span>
                  <div>
                    <small>Call us</small>
                    <a href="tel:+16043655225">(604) 365-5225</a>
                  </div>
                </li>
                <li>
                  <span className="icon-chip">
                    <Mail />
                  </span>
                  <div>
                    <small>Email</small>
                    <a href="mailto:ivyleaguepaint@gmail.com">ivyleaguepaint@gmail.com</a>
                  </div>
                </li>
                <li>
                  <span className="icon-chip">
                    <Pin />
                  </span>
                  <div>
                    <small>Office</small>
                    <span>1215C 56 St, Delta, BC</span>
                  </div>
                </li>
              </ul>
            </div>
            <div className="contact__form">
              <Form />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
